module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-17-60382f5127c7037715bf06e10b4d9077.jpg";